import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { initRouterController } from './router/globalController';
import store from './store';
import plugins from './lib/plugins';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Copy from 'v-copy';
import reporter from './lib/reporter';
import { errFunc } from '@/lib/utils';
/**
 * 自定义插件
 * 指令、筛选器、mixins、第三方库……
 */
Vue.use(plugins);
Vue.use(Copy);

// element-ui
Vue.use(ElementUI, { size: 'small', zIndex: 3000 });
Vue.prototype.$error = errFunc;

Vue.config.errorHandler = function(err) {
  reporter.log({ message: err.stack || err.message });
  console.error(err);
};

Vue.config.productionTip = false;

const renderAppHandle = async () => {
  if (location.hash.slice(0, 21) === '#/sentencing-register') {
    sessionStorage.setItem('to_sentencing', 1);
  }

  // 初始化用户登录状态
  await store.dispatch('initUserAuthriozation');

  // 注册全局路由
  initRouterController({ router, store });

  // registerChartTheme();

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
};

renderAppHandle();

// 注册echarts主题
// function registerChartTheme() {
//   chartThemeArr.forEach(async item => {
//     const themeItem = await import(/* webpackChunkName: "chart-theme" */ `@/assets/chartTheme/${item.key}`);
//     registerTheme(item.key, themeItem.theme);
//   });
// }
